/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { API } from 'aws-amplify';
import { I18n } from '@aws-amplify/core';

//Branded Theme
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../branding';

import * as Sentry from "@sentry/react";

const mapStateToProps = (state) => {
	return {
		auth: state.app.auth,
		lang: state.app.lang,
		queryParameters: state.app.queryParameters
	}
}

class Dashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			registeredClients: [],
			snackBarOps: {
				type: 'info',
				open: false,
				vertical: 'top',
				horizontal: 'center',
				autoHide: 0,
				message: ''
			}
		}
	}

	componentDidMount() {
		this.getClients();
	}

	/*
	 * API call to get the Apps (Clients) for Single Sign On (SSO)
	 * Each App will shown with Logo, Name and a Link to LogbackUri
	 */
	getClients() {
		const apiName = 'amplifyIdentityBrokerApi';
		const path = '/clients';

		API
			.get(apiName, path)
			.then(response => {
				this.setState({ registeredClients: response });
			})
			.catch(err => {
				console.log(err);
				Sentry.captureException(err);
				this.setState({
					snackBarOps: {
						type: 'error',
						open: true,
						vertical: 'top',
						horizontal: 'center',
						autoHide: 3000,
						message: I18n.get("DASHBOARD_ERROR_MESSAGE")
					}
				});
			});
	}

	render() {
		const queryParams = new URLSearchParams(this.props.queryParameters);
		const redirect_uri = queryParams?.get("redirect_uri");
		return (
			<MuiThemeProvider theme={theme}>
				<div style={{ backgroundColor: "#287C2D", height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
					<div style={{ display: "flex", marginBottom: 20 }}>
						<img src="/images/tnmedia_righe_or_wh.png" alt="Logo Tecniche Nuove"
							style={{ marginRight: 30, maxWidth: 250 }} />
						<span className="loaderTn"></span>
					</div>
					{
						redirect_uri ?
							<p style={{ color: "white", maxWidth: 450, textAlign: "center", lineHeight: "22px" }}>{`Stiamo completando il tuo accesso. Grazie per la tua pazienza. Sarai reindirizzato al sito tra poco`}</p>
							: null
					}

				</div>

			</MuiThemeProvider>
		)
	}
}

export default withRouter(connect(mapStateToProps, {})(Dashboard));
